import { graphqlClient } from '@/lib/graphql-client';
import {
  buildGetConditionalOffersQuery,
  buildGetDepartmentsLookupQuery,
  buildGetEmployeesLookupQuery,
} from '../graphql/queries';
import { INSERT_CONDITIONAL_OFFER_MUTATION } from '../graphql/mutations';
import {
  ConditionalOffersPagingResult,
  ConditionalOfferInsertInput,
  DepartmentOption,
  EmployeesLookupResult,
  GetConditionalOffersParams,
} from '../types/offer.types';

export const getConditionalOffers = async (
  params: GetConditionalOffersParams
): Promise<{ ConditionalOffers: ConditionalOffersPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetConditionalOffersQuery(filter, pageNo, pageSize, order),
  });
};

export const getDepartmentsLookup = async (): Promise<{
  Departments: { items: DepartmentOption[] };
}> => {
  return graphqlClient.query({
    query: buildGetDepartmentsLookupQuery({}, 1, 300),
  });
};

export const getEmployeesLookup = async (
  keyword = ''
): Promise<{ Employees: EmployeesLookupResult }> => {
  const filter = keyword ? { DisplayName: { $regex: keyword, $options: 'i' } } : {};
  return graphqlClient.query({
    query: buildGetEmployeesLookupQuery(filter, 1, 50),
  });
};

export const createConditionalOffer = async (input: ConditionalOfferInsertInput) => {
  return graphqlClient.mutate({ query: INSERT_CONDITIONAL_OFFER_MUTATION, variables: { input } });
};
